import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Seo } from "@/components/Seo";
import { Loader2, Lock, Sparkles } from "lucide-react";

export default function Lookbook() {
  const [items, setItems] = useState(null);
  const [community, setCommunity] = useState([]);
  useEffect(() => {
    api.products({ trending: true, sort: "trending" }).then(({ data }) => setItems(Array.isArray(data) ? data : data.items));
    api.lookbookCommunity().then(({ data }) => setCommunity(data)).catch(() => {});
  }, []);
  return (
    <div data-testid="lookbook-page" className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-14">
      <Seo title="The Lookbook — Editorial Formalwear" description="Heather's curated prom & homecoming lookbook — the season's most-loved silhouettes, styled for you." path="/lookbook" />
      <p className="font-label text-[10px] text-rosemetal mb-3">The Lookbook</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-none mb-3">This season, styled.</h1>
      <p className="font-body text-sm text-muted-foreground max-w-md mb-12">The looks turning heads across Wisconsin — trending silhouettes, hand-picked by Heather.</p>

      {community.length > 0 && (
        <section data-testid="lookbook-community" className="mb-20">
          <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
            <div>
              <p className="font-label text-[10px] text-rosemetal mb-2 flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5" /> Locked Looks</p>
              <h2 className="font-display text-3xl sm:text-4xl">Real girls, real dresses — claimed.</h2>
            </div>
            <p className="font-body text-xs text-muted-foreground max-w-xs">AI try-ons shared by students across Wisconsin. Tap a look to see the dress.</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {community.slice(0, 10).map((l, i) => (
              <Link key={i} to={`/product/${l.product_id}`} data-testid={`community-look-${i}`} className="relative rounded-sm overflow-hidden group border border-border">
                <div className="aspect-[3/4] bg-blush"><img src={`${process.env.REACT_APP_BACKEND_URL}${l.image_url}`} alt={`${l.first_name}'s look`} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]" /></div>
                <span className="absolute top-2.5 left-2.5 glass-dark text-ivory font-label text-[8px] px-2.5 py-1 rounded-full flex items-center gap-1"><Lock className="w-2.5 h-2.5 text-champagne" /> Locked</span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink via-ink/70 to-transparent p-3 pt-10 text-ivory">
                  <p className="font-display text-lg leading-none">{l.first_name}</p>
                  <p className="font-label text-[7px] text-champagne mt-1 truncate">{l.school_name || "Wisconsin"} · {l.event}</p>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}

      {!items ? (
        <div className="h-[40vh] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-rosemetal" /></div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10">
          {items.slice(0, 24).map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
